"use client";
import { Spinner } from "@/components/spinner";
import { useCidadao } from "@/providers/cidadao-provider";
import React, { useEffect, useState } from "react";
import { LoginButton } from "./login-button";
import { MenuDropdown } from "./menu-dropdown";

export function UserMenu() {
  const { cidadao, isLoading } = useCidadao();
  const [isLoggedIn, setIsLoggedIn] = React.useState(!!cidadao);

  const [href, setHref] = useState("");
  
    useEffect(() => {
      setHref(isLoggedIn
    ? `${process.env.NEXT_PUBLIC_APEX_URL}/auth/logout`
    : `${process.env.NEXT_PUBLIC_LOGIN_URL}${window.location.href}`);
    }, [setHref, isLoggedIn]);

  React.useEffect(() => {
    setIsLoggedIn(!!cidadao);
  }, [cidadao]);

  if (isLoading)
    return (
      <div className="flex justify-center items-center w-5 xl:w-10 h-5 xl:h-10">
        <Spinner />
      </div>
    );

  if (!isLoggedIn) return <LoginButton href={href} />;

  return <MenuDropdown name={cidadao?.nome} href={href} />;
}
